import { connect } from 'react-redux';

import LearningAdminModuleSeriesGridScreen from '../components/LearningAdminModuleSeriesGridScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const moduleSerieTypes = [
  {
    action: 'recommended',
    value: true,
  },
  {
    action: 'recommended_not',
    value: false,
  },
];

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  let total = 0;

  moduleSerieTypes.forEach((x) => {
    total +=
      state.learningsAdmin.getIn(
        [
          'moduleSeriesAdmin',
          'list',
          partnershipId,
          x.action,
          'totalModuleSeriesAdmin',
        ],
        0
      ) || 0;
  });

  return {
    total,
    moduleSerieTypes: moduleSerieTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminModuleSeriesGridScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSeriesGridScreen);

export default LearningAdminModuleSeriesGridScreenContainer;
